<template>
    <div class="bizcomp-trade trade-box">
        <el-tabs v-model="activeType" class="tab" v-on:tab-click="handleClick">
            <el-tab-pane name="trade" label="交易记录"></el-tab-pane>
            <el-tab-pane
                v-if="redemptionRecordDisplay"
                name="redemptionRecord"
                label="预约赎回记录"
            ></el-tab-pane>
            <el-tab-pane
                v-if="
                    $const.monthlyStatementDisplay &&
                    $util.getConfig().hideFunc &&
                    monthlyStatementDisplay !== false
                "
                name="statement"
                label="对账单查询"
            >
                <monthly-statement></monthly-statement>
            </el-tab-pane>
        </el-tabs>
        <div v-if="activeType == 'trade'">
            <div class="filter-box">
                <el-select
                    v-model="sourceflag"
                    placeholder="选择销售渠道"
                    class="grow-class"
                    size="small"
                    style="width: 100px"
                >
                    <el-option
                        v-for="item in sourceList"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                    ></el-option>
                </el-select>
                <el-select
                    v-model="tradeType"
                    placeholder="选择交易类型"
                    class="grow-class"
                    size="small"
                    style="width: 150px"
                >
                    <el-option
                        v-for="item in tradeTypes"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                    ></el-option>
                </el-select>
                <!-- <el-select
                    v-model="tradeStatus"
                    placeholder="选择交易状态"
                    class="grow-class"
                    size="small"
                    style="width: 150px"
                >
                    <el-option
                        v-for="item in statusList"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                    ></el-option>
                </el-select> -->
                <div class="trade-search">
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入基金代码/名称"
                        class="input-search"
                        size="small"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                        <el-button
                            slot="prefix"
                            icon="el-icon-search"
                            class="search-icon"
                            type="text"
                            size="small"
                            v-on:click="searchTrade"
                        />
                    </el-autocomplete>
                </div>
                <date-picker
                    :date="dateSet"
                    sep-text="-"
                    style="width: 310px"
                    v-on:date-get="dateInterval"
                />
                <el-button
                    size="small"
                    type="primary"
                    style="background-color: var(--color-primary); color: var(--color-text-white)"
                    v-on:click.prevent="searchDateTrade"
                >
                    查询
                </el-button>
            </div>
            <el-row v-if="tradeList.length <= 0 && hasLoad" class="no-funds">
                <el-col :span="12" :offset="8">
                    <span class="no-funds-img" />
                    <div class="no-funds-box">
                        <p>暂无数据</p>
                    </div>
                </el-col>
            </el-row>
            <el-table
                v-else-if="hasLoad"
                :data="tradeList"
                class="tab-list-tit"
                :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
            >
                <el-table-column
                    prop="fundname"
                    label="产品名称"
                    width="200"
                    class-name="fund-offset"
                >
                    <template slot-scope="scope">
                        <div class="fund-name">
                            {{ scope.row.fundname }}
                        </div>
                        <div style="color: var(--color-text-accent)">
                            {{ scope.row.fundcode }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="businesscode" label="交易类型" align="center">
                    <template slot-scope="scope">
                        <div class="business-code">
                            <img
                                v-if="scope.row.custtag == '1'"
                                class="custtag"
                                :src="require('../../assets/img/custtag.png')"
                            />
                            <span>{{ formatterTran(scope.row) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="operdate"
                    :label="sourceflag == '2' ? '申请日期' : '交易时间'"
                    align="center"
                >
                    <template slot-scope="scope">
                        <div style="color: var(--color-text-primary)">
                            {{
                                sourceflag == "2"
                                    ? $util.fmtDate(scope.row.transactiondate)
                                    : $util.fmtDate(scope.row.operdate)
                            }}
                        </div>
                        <div style="color: var(--color-text-accent)">
                            {{ sourceflag == "2" ? "" : $util.fmtTime(scope.row.opertime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="sourceflag == '2' ? '交易状态' : '申请状态'"
                    align="center"
                    :formatter="formatterCfmStatus"
                ></el-table-column>
                <el-table-column
                    prop="appdata"
                    label="申请金额/份额"
                    align="center"
                    :formatter="formatterAmount"
                ></el-table-column>
                <el-table-column
                    label="确认金额/份额"
                    align="center"
                    :formatter="formatterCfmAmount"
                ></el-table-column>
                <el-table-column
                    prop="distributorcode"
                    label="销售商"
                    align="center"
                    :formatter="formatterDistributor"
                ></el-table-column>
                <el-table-column label="操作" align="center" min-width="100">
                    <template slot-scope="scope">
                        <div class="btns">
                            <el-button
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="showDetail(scope.row)"
                            >
                                详情
                            </el-button>
                            <div
                                v-if="scope.row.cancelflag == '1' && sourceflag != '2'"
                                class="line"
                            ></div>
                            <el-button
                                v-if="scope.row.cancelflag == '1'"
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="showCancel(scope.row)"
                            >
                                撤单
                            </el-button>
                        </div>
                        <div
                            v-if="
                                (scope.row.paychannel == '0001' ||
                                    scope.row.paymethod == '2' ||
                                    scope.row.paymethod == '3') &&
                                scope.row.status != '06' &&
                                (scope.row.businesscode == '020' || scope.row.businesscode == '022')
                            "
                        >
                            <el-button
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="showHkinfo(scope.row)"
                            >
                                查看收款账户信息
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="allPage > 0" class="page-box">
                <el-pagination
                    :page-size="Number(conf.PAGE_SIZE)"
                    :current-page.sync="curPage"
                    layout="->, total, prev, pager, next"
                    :total="Number(allPage)"
                    v-on:current-change="newTrade"
                />
            </el-row>
        </div>

        <div v-if="activeType == 'redemptionRecord'">
            <el-row v-if="redemptionRecordList.length <= -50" class="no-funds">
                <el-col :span="12" :offset="8">
                    <span class="no-funds-img" />
                    <div class="no-funds-box">
                        <p>暂无数据</p>
                    </div>
                </el-col>
            </el-row>
            <el-table
                v-else
                :data="redemptionRecordList"
                class="tab-list-tit"
                :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
            >
                <el-table-column
                    prop="fundname"
                    label="产品名称"
                    width="220"
                    class-name="fund-offset"
                >
                    <template slot-scope="scope">
                        <div class="fund-name">
                            {{ scope.row.fundname }}
                        </div>
                        <div style="color: var(--color-text-accent)">
                            {{ scope.row.fundcode }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="businesscode" label="交易类型" align="center">
                    <template slot-scope="scope">
                        <div class="business-code">
                            <img
                                v-if="scope.row.custtag == '1'"
                                class="custtag"
                                :src="require('../../assets/img/custtag.png')"
                            />
                            <span>{{ formatterTran(scope.row) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="operdate" label="交易时间" align="center">
                    <template slot-scope="scope">
                        <div style="color: var(--color-text-primary)">
                            {{ $util.fmtDate(scope.row.operdate) }}
                        </div>
                        <div style="color: var(--color-text-accent)">
                            {{ $util.fmtTime(scope.row.opertime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="预约状态"
                    align="center"
                    :formatter="formatterStatus"
                ></el-table-column>
                <el-table-column
                    prop="appdata"
                    label="申请金额/份额"
                    align="center"
                    :formatter="formatterAmount"
                ></el-table-column>
                <!-- <el-table-column
                    prop="distributorcode"
                    label="销售商"
                    align="center"
                    :formatter="formatterDistributor"
                ></el-table-column> -->
                <el-table-column label="操作" align="center" min-width="100">
                    <template slot-scope="scope">
                        <div class="btns">
                            <el-button
                                v-if="scope.row.status == 'N'"
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="showRedemptionCancel(scope.row)"
                            >
                                撤单
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="allRedemptionRecordPage > 0" class="page-box">
                <el-pagination
                    :page-size="Number(conf.PAGE_SIZE)"
                    :current-page.sync="redemptioncurPage"
                    layout="->, total, prev, pager, next"
                    :total="Number(allRedemptionRecordPage)"
                    v-on:current-change="newRedemption"
                />
            </el-row>
        </div>

        <my-dialog
            class="my-dialog-contain"
            title="交易详情"
            :visible="detailVisible"
            width="580px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div v-for="(item, index) in tradeDetail" :key="index" class="trade-item">
                    <span class="label">{{ item.label }}</span>
                    <span class="val" style="max-width: 330px">{{ item.val }}</span>
                </div>
                <el-button type="primary" class="btn ensure" v-on:click="dialogClose">
                    确定
                </el-button>
            </div>
        </my-dialog>
        <my-dialog
            class="my-dialog-contain"
            title="交易撤单"
            :visible="cancelVisible"
            width="580px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div v-for="(item, index) in cancelDetail" :key="index" class="trade-item">
                    <span class="label">{{ item.label }}</span>
                    <span
                        v-if="item.type != 'channel'"
                        class="val"
                        :class="item.type == 'amount' && item.val != '--' ? 'amount' : ''"
                    >
                        {{ item.val }}
                    </span>
                    <span v-if="item.type == 'amount' && item.val != '--'">元</span>
                    <div v-if="item.type == 'channel'">
                        <el-radio v-model="payChannel" label="1">
                            回到{{ $const.getXJBParam("sname") }}
                        </el-radio>
                        <el-radio v-model="payChannel" label="0">回到银行卡</el-radio>
                    </div>
                </div>
                <el-form
                    v-if="isPwdCheck"
                    ref="ruleForm"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="100px"
                    size="small"
                    style="margin: 0 60px"
                >
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            style="width: 340px"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入"
                        />
                    </el-form-item>
                </el-form>
                <div class="btns">
                    <el-button class="btn back" v-on:click="dialogClose">返回</el-button>
                    <el-button type="primary" class="btn" v-on:click="cancelConfirm">
                        确定
                    </el-button>
                </div>
            </div>
        </my-dialog>
        <my-dialog
            class="my-dialog-contain"
            title="撤单申请结果"
            :visible="resultVisible"
            width="700px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div class="success-box">
                    <img class="success" :src="require('../../assets/img/success.png')" />
                    <div class="tip">撤单申请已提交！</div>
                </div>
                <div class="btns">
                    <el-button class="btn back" v-on:click="backHome">返回首页</el-button>
                    <el-button class="btn" v-on:click="gotoBuy">买基金</el-button>
                </div>
                <div class="warm-tip">
                    <div style="font-size: 16px">温馨提示</div>
                    <div style="margin-top: 10px">
                        1、申购撤单后，申购资金在申请撤单后1个工作日划出，即T+1划款。
                    </div>
                    <div style="margin-top: 10px">
                        2、赎回撤单后，冻结份额在赎回撤单后立即解冻。
                    </div>
                </div>
            </div>
        </my-dialog>
        <my-dialog
            class="my-dialog-contain"
            title="收款账户信息"
            :visible="hkinfoVisible"
            width="580px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div class="hk-class">
                    <div class="copy-set" v-on:click="copy(1)">一键复制</div>
                    <div class="card-info">
                        <div class="card-detail">
                            <span class="hk-title">银行户名：{{ hkinfo.acctname }}</span>
                            <span class="copy" v-on:click="copy(2)">复制</span>
                        </div>
                        <div class="card-detail">
                            <span class="hk-title">银行账号：{{ hkinfo.acctcode }}</span>
                            <span class="copy" v-on:click="copy(3)">复制</span>
                        </div>
                        <div class="card-detail">
                            <span class="hk-title">
                                <span style="white-space: nowrap">&nbsp;&nbsp;&nbsp;开户行：</span>
                                <span class="text-wrap">{{ hkinfo.bankname }}</span>
                            </span>
                            <span class="copy" v-on:click="copy(4)">复制</span>
                        </div>
                    </div>
                </div>
                <el-button type="primary" class="btn ensure" v-on:click="dialogClose">
                    确定
                </el-button>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker";
import myDialog from "@/components/layout/myDialog.vue";
import MonthlyStatement from "./monthlyStatement.vue";
import userApi from "@/api/user";

export default {
    name: "TradeHistory",
    components: {
        datePicker,
        myDialog,
        MonthlyStatement
    },
    mixins: [mixin],
    data() {
        return {
            activeType: "trade", // tab类型
            sourceList: [
                { val: "1", text: "直销" },
                { val: "2", text: "代销" }
            ], // 销售渠道集合
            sourceflag: "1", // 销售渠道
            tradeType: null, // 交易类型
            tradeTypes: [
                { val: "", text: "全部" },
                { val: "020,022,130", text: "认/申购" },
                { val: "024,098", text: "赎回/T+0快速赎回" },
                { val: "036", text: "转换" },
                { val: "059,039,060,061,0G1,0G2", text: "定投" },
                { val: "029", text: "修改分红方式" },
                { val: "143", text: "分红" },
                { val: "026", text: "跨系统转托管" },
                { val: "027", text: "转托管入直销" }
            ], // 交易类型集合
            tradeStatus: null, // 交易状态
            statusList: [], // 交易状态数组
            conf: {}, // 初始化配置文件内容
            searchText: "", // 搜索文本内容
            tradeList: [], // 交易记录列表
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            curPage: 1, // 当前页
            hasLoad: false, // 是否已经查询数据
            endDate: "",
            beginDate: "",
            nowDate: "", // 当前时间
            dateSet: {
                type: "2",
                min: "1990-01-01",
                size: "mini",
                text: "开始时间",
                text2: "结束时间"
            },
            detailVisible: false, // 是否显示详情弹窗
            tradeDetail: null, // 交易详情
            cancelVisible: false, // 是否显示撤单弹窗
            hkinfoVisible: false, // 是否显示收款账户信息
            cancelDetail: null, // 撤单详情
            isPwdCheck: false,
            // 撤单密码校验
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            selectTrade: null, // 所选交易记录
            selectRedemption: null, // 所选预约赎回记录
            cancelType: "trade", // 撤单类型 trade-交易撤单 redemption-预约赎回撤单
            payChannel: "1", // 撤单退款方式 0-银行卡 1-实时TA，不传默认回实时TA
            resultVisible: false, // 是否显示撤单成功弹窗
            hkinfo: {},
            monthlyStatementDisplay: true, // 控制对账单入口
            redemptionRecordDisplay: true, // 预约赎回记录入口
            redemptionRecordList: [], // 预约赎回记录列表
            allRedemptionRecordPage: "0", // 所有数据条数
            redemptionPagecount: 10, // 分页条数
            redemptionPageoffset: 1, // 起始页
            redemptioncurPage: 1, // 当前页
            userInfo: {} // 用户信息
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchTrade();
            }
        },
        sourceflag() {
            this.pageoffset = 1;
            this.tradeList = [];
            this.allPage = "0";
            this.doAction();
        },
        tradeType() {
            this.pageoffset = 1;
            this.doAction();
        },
        tradeStatus() {
            this.pageoffset = 1;
            this.doAction();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.userInfo = this.$cache.getUser();
        this.monthlyStatementDisplay =
            this.$cache.getParamValue("trade_info") &&
            this.$cache.getParamValue("trade_info").showtradestatement;

        this.redemptionRecordDisplay =
            this.$cache.getParamValue("trade_info") &&
            this.$cache.getParamValue("trade_info").bookingtradeenable;

        this.handletradeType();
        // 纯代销用户进来查代销交易记录
        if (this.$cache.getCustnoCrm() && !this.$cache.getBinded()) {
            this.sourceflag = "2";
        }
        this.conf = this.$util.getConfig().const;
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.assignStatusList();
        this.isPwdCheck = this.$cache.getPwdCheck("52");
        this.activeType = this.$route.query.activeType ? this.$route.query.activeType : "trade";
        if (this.activeType === "redemptionRecord") {
            this.getRedemptionRecordList();
        } else {
            this.doAction();
        }
    },
    methods: {
        handletradeType() {
            const finalTradeTypes = this.tradeTypes.filter((type) => {
                // 保留非托管相关条目
                if (type.val !== "026" && type.val !== "027") return true;
                // 根据开关动态显示托管条目
                if (type.val === "026")
                    return (
                        (this.$cache.getParamValue("business_module") &&
                            this.$cache.getParamValue("business_module").bizenable["026"]) !== false
                    );
                if (type.val === "027")
                    return (
                        this.$cache.getParamValue("business_module") &&
                        this.$cache.getParamValue("business_module").bizenable["027"]
                    );
                return true;
            });
            this.tradeTypes = finalTradeTypes;
        },
        handleClick() {
            if (this.activeType == "trade") {
                this.searchTrade();
            } else if (this.activeType == "redemptionRecord") {
                this.getRedemptionRecordList();
            }
        },
        // 赋值交易状态列表
        assignStatusList() {
            let array = [];
            array.push({ val: "", text: "全部" });
            const list = this.$cache.getDict("23061001", undefined);
            list.forEach((item) => {
                const status = { val: item.subitem, text: item.subitemname };
                array.push(status);
            });
            this.statusList = array;
        },
        // 获取新一页数据
        newTrade(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 获取新一页数据
        newRedemption(val) {
            this.redemptionPageoffset = val;
            this.getRedemptionRecordList();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                if (cb) {
                    _this.getFundList(val, cb);
                } else {
                    _this.getTradeList();
                }
            }, 500);
        },
        // 获取基金列表
        async getFundList(val, cb) {
            let isnotincludespecial = "";
            if (
                this.$util.isEmpty(this.userInfo.accreditedinvestor) ||
                this.userInfo.accreditedinvestor === "0"
            ) {
                isnotincludespecial = "1";
            }
            const res = await fundApi.getFundLists({
                keyword: val,
                pagesize: "20",
                pagenum: "1",
                tradingmethod: this.$util.getConfig().systemtype,
                isnotincludespecial
            });
            if (res.data) {
                cb(res.data.list || []);
            }
        },
        // 获取交易信息
        async getTradeList(val, cb) {
            if (!this.$cache.getBinded() && !this.$cache.getCustnoCrm()) {
                return;
            }
            if (this.$util.isEmpty(this.beginDate) != this.$util.isEmpty(this.endDate)) {
                let _m = "请输入完整的日期范围";
                this.$alert(_m, "日期提示");
                this.fund = [];
                return;
            }
            let tradeType = this.tradeType;
            if (!tradeType) {
                const valArray = this.tradeTypes
                    .map((item) => item.val) // 提取所有 val
                    .filter((val) => val !== "");
                tradeType = valArray.join(",");
            }
            const _x = {
                orderstartdate: this.beginDate,
                orderenddate: this.endDate,
                businesscodestr: tradeType,
                status: this.tradeStatus,
                sourceflag: "",
                realtatradepackflag: "1",
                keyword: val || this.searchText,
                pagesize: cb ? "10" : this.pagecount,
                pagenum: val ? "1" : this.pageoffset,
                appflag: "0"
            };
            let res = null;
            if (this.sourceflag == "2") {
                // 代销交易记录
                _x.sourceflag = "2";
                res = await fundApi.qryCrmTransConfirm(_x);
            } else {
                if (!this.$cache.getBinded()) {
                    this.hasLoad = true;
                    return;
                }
                // 直销交易记录
                res = await fundApi.qryOrderListService(_x);
            }
            this.hasLoad = true;
            if (res.data) {
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.tradeList = res.data.data;
                }
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, res.data.data);
                }
            }
        },
        // 获取预约赎回记录信息
        async getRedemptionRecordList(val, cb) {
            const _x = {
                fundcode: "",
                sellflag: "",
                planno: "",
                saveplanflag: "2",
                pageSize: this.redemptionPagecount,
                pageNum: val ? "1" : this.redemptionPageoffset
            };
            let res = await fundApi.combQueryAgrPlan(_x);

            this.hasLoad = true;
            if (res.data) {
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.redemptionRecordList = res.data.data;
                }
                if (!cb) {
                    this.allRedemptionRecordPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, res.data.data);
                }
            }
        },
        // 搜索交易记录
        searchTrade() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 搜索时间区间交易记录
        searchDateTrade() {
            this.curPage = 1;
            this.pageoffset = "1";
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterName(row, column, value) {
            if (
                row.businesscode === "D2" ||
                row.businesscode === "069" ||
                (row.businesscode === "024" &&
                    (row.businesskind === "2" || row.businesskind === "6"))
            ) {
                return row.targetfundname
                    ? row.targetfundname + "(" + row.targetfundcode + ")"
                    : "--";
            }
            return row.fundname + "(" + row.fundcode + ")";
        },
        formatterNameCC(row, column, value) {
            return value ? row.targetfundname + "(" + row.targetfundcode + ")" : "--";
        },
        formatterDistributor(row, column, value) {
            if (this.sourceflag == "2") {
                return row.distributorname
                    ? row.distributorname
                    : row.distributorcode
                    ? "代销-" + this.$cache.getDict("110070", row.distributorcode)
                    : "--";
            }
            if (row.bankcode) {
                return (
                    "直销-" +
                    this.$cache.getDict("110080", row.bankcode) +
                    (row.paychannelname ? "-" + row.transidpaychannelname : "")
                );
            }
            return row.bankname ? "直销-" + row.bankname + "-" + row.transidpaychannelname : "--";
        },
        formatterTran(row) {
            return (
                (row.paymethod == "1" || row.custtag == "1"
                    ? this.$const.getXJBParam("sname") + "-"
                    : "") + this.$cache.getDict("130010", row.businesscode)
            );
        },
        formatterAmount(row, column, value) {
            if (this.activeType == "redemptionRecord") {
                return this.$util.fmtNum(row.sellvol);
            } else {
                return this.$util.fmtNum(Number(row.appamount) || Number(row.appvol));
            }
        },
        formatterCfmAmount(row, column, value) {
            return row.confirmedamount > 0
                ? this.$util.fmtNum(row.confirmedamount)
                : this.$util.fmtNum(row.confirmedvol);
        },
        formatterCfmStatus(row) {
            // 01，02，06，10 展示为 处理中；
            // 04，08 展示为失败；
            // 05 展示为已撤单；
            // 07 展示为成功；
            // 09 展示为部分成功

            // 判断是否是直销
            if (this.sourceflag != "2") {
                const _status = row.transstatus;
                if (_status === "01" || _status === "10") {
                    return "处理中";
                } else if (_status === "04" || _status === "08") {
                    return "失败";
                } else if (_status === "02" || _status === "06") {
                    if (["020", "022", "130"].indexOf(row.businesscode) > -1) {
                        return "处理中(支付成功)";
                    }
                    return "处理中";
                } else if (_status === "05") {
                    return "已撤单";
                } else if (_status === "07") {
                    return "成功";
                } else if (_status === "09") {
                    return "部分成功";
                }
                return "";
            } else {
                if (row.businesscode === "026" && row.transstatus == "02") {
                    return "申请有效";
                }
                if (row.transstatus == "04") {
                    return "下单失败";
                }
                let status =
                    row.status === "01" ? "确认成功" : row.status === "02" ? "确认失败" : "";
                if (!status) {
                    if (!this.$util.isEmpty(row.status)) {
                        status = this.$cache.getDict("23061001", row.status) || row.status;
                        if (status == "无需支付" && row.custtag == "1") {
                            status = "支付成功";
                        }
                    } else {
                        if (!this.$util.isEmpty(row.paystatus)) {
                            if (row.paystatus == "00") {
                                status = "待支付";
                            } else if (row.paystatus == "01") {
                                status = "支付处理中";
                            } else {
                                if (row.paystatus == "04" && row.custtag == "1") {
                                    status = "支付成功";
                                } else {
                                    status = this.$cache.getDict("110077", row.paystatus);
                                }
                            }
                        }
                    }
                }
                return status;
            }
        },
        formatterStatus(row) {
            if (row.status == "N") {
                return "待生效";
            } else if (row.status == "Z") {
                return "已生效";
            } else {
                return "已失效";
            }
        },
        // 支付方式过滤方法
        formatterPaychannel(row) {
            let paychannelName = "";
            if (!this.$util.isEmpty(row.paychannelname)) {
                if (row.paymethod == "2" || row.paymethod == "3") {
                    paychannelName = "汇款支付";
                } else if (row.paymethod == "1") {
                    paychannelName = this.$const.getXJBParam("sname");
                } else {
                    paychannelName = "银行卡支付";
                }
            }
            return paychannelName;
        },
        // 支付状态过滤方法
        formatterPaystatus(row) {
            let status = "";
            if (!this.$util.isEmpty(row.paystatus)) {
                if (row.paystatus == "00") {
                    // transstatus 为 04申请作废 / 05已撒单 / 13撒单中 时，不转译，直接用字典展示
                    const cancelStatus = ["04", "05", "13"];
                    if (cancelStatus.includes(row.transstatus)) {
                        status = this.$cache.getDict("110077", row.paystatus);
                    } else {
                        status = "待支付";
                    }
                } else if (row.paystatus == "01") {
                    status = "支付处理中";
                } else {
                    status = this.$cache.getDict("110077", row.paystatus);
                }
            }
            return status;
        },
        // 判断是买入业务还是卖出业务
        isBuyType(businesscode) {
            if ("024,026,036,098".indexOf(businesscode) != -1) {
                return false;
            }
            return true;
        },
        // 显示交易详情弹窗
        async showDetail(item) {
            let res = {};
            try {
                if (this.sourceflag != "2") {
                    // 直销数据
                    res = await fundApi.qryOrderDetailService({
                        appsheetserialno: item.appsheetserialno
                    });
                } else {
                    // 代销数据
                    res.data = {};
                }
            } catch (e) {
                res.data = {};
            }
            const detail = Object.assign({}, res.data || {}, item);
            if (detail.businesscode == "029") {
                if (detail.dividendmethod == "0") {
                    // 红利再投资
                    detail.dividendmethoddetail = "3";
                } else {
                    if (detail.dividendcashbacktype == "1") {
                        // 自动充值至钱柜
                        detail.dividendmethoddetail = "1";
                    } else {
                        // 发放至银行卡
                        detail.dividendmethoddetail = "2";
                    }
                }
            }
            let array = [];
            array.push({
                label: "基金名称：",
                val: `${detail.fundname}[${detail.fundcode}]`
            });
            if (
                detail.businesscode == "036" &&
                detail.targetfundname &&
                detail.targetfundcode
            ) {
                array.push({
                    label: "转入基金：",
                    val: `${detail.targetfundname}[${detail.targetfundcode}]`
                });
            }
            array.push({
                label: "业务类型：",
                val:
                    this.$cache.getDict("130010", detail.businesscode) +
                    (detail.businesscode == "029"
                        ? "-" + this.$cache.getDict("90273", detail.dividendmethoddetail)
                        : "")
            });
            array.push({
                label: "销售机构：",
                val: this.formatterDistributor(item)
            });
            if (item.transactioncfmdate && item.status == "01") {
                array.push({
                    label: "确认日期：",
                    val: this.$util.fmtDate(detail.transactioncfmdate)
                });
            }
            array.push({
                label: "确认金额：",
                val: this.$util.fmtNum(detail.confirmedamount)
            });
            array.push({
                label: "确认份额：",
                val: this.$util.fmtNum(detail.confirmedvol)
            });
            if (this.sourceflag == "2") {
                array.push({
                    label: "申请日期：",
                    val: `${this.$util.fmtDate(detail.transactiondate)}`
                });
            } else {
                array.push({
                    label: "交易时间：",
                    val: `${this.$util.fmtDate(detail.operdate)} ${this.$util.fmtTime(
                        detail.opertime
                    )}`
                });
            }
            if (this.isBuyType(detail.businesscode)) {
                array.push({
                    label: "申请金额：",
                    val: this.formatterAmount(detail)
                });
            } else {
                array.push({
                    label: "申请份额：",
                    val: this.formatterAmount(detail)
                });
            }
            if (this.sourceflag != "2" && detail.depositcard) {
                array.push({
                    label: "扣款账号：",
                    val: `${this.$cache.getDict(
                        "110080",
                        detail.bankcode
                    )} (${detail.depositcard ? detail.depositcard.substr(-4, 4) : "--"})`
                });
            }
            if (detail.businesscode == "020" || detail.businesscode == "022") {
                array.push({
                    label: "支付方式：",
                    val: this.formatterPaychannel(detail)
                });
                array.push({
                    label: "支付状态：",
                    val: this.formatterPaystatus(detail)
                });
            }
            array.push({
                label: "交易状态：",
                val: this.formatterCfmStatus(detail)
            });
            array.push({
                label: "确认净值：",
                val: this.$util.fmtNum(detail.nav, 4)
            });
            array.push({
                label: "手续费：",
                val: this.$util.fmtNum(detail.charge)
            });
            const custText = detail.custtag == "1" ? "是" : "否";
            array.push({
                label: "收费方式：",
                val: detail.sharetype && detail.sharetype.trim()
                    ? this.$cache.getDict("130000", detail.sharetype)
                        ? this.$cache.getDict("130000", detail.sharetype)
                        : "--"
                    : "--"
            });
            const fundRes = await fundApi.getFundLists({
                fundcode: item.fundcode,
                pagesize: 10,
                pagenum: 1
            }).catch(() => ({ data: null }));
            if (fundRes.data && fundRes.data.list && fundRes.data.list.length > 0) {
                const fundInfo = fundRes.data.list[0];
                if (
                    fundInfo.businessflag &&
                    fundInfo.businessflag.indexOf("FM") > -1 &&
                    ["024", "036", "138", "150", "142"].includes(detail.businesscode)
                ) {
                    array.push({
                        label: "返还或有管理费：",
                        val: detail.achievementcompen || "--"
                    });
                    array.push({
                        label: "超额管理费：",
                        val: detail.achievementpay || "--"
                    });
                }
            }
            this.tradeDetail = array;
            this.detailVisible = true;
        },
        // 关闭交易详情弹窗
        dialogClose() {
            if (this.ruleForm.tradepwd) {
                this.ruleForm.tradepwd = "";
            }
            this.detailVisible = false;
            this.cancelVisible = false;
            this.resultVisible = false;
            this.hkinfoVisible = false;
        },
        // 显示撤单
        async showCancel(item) {
            this.cancelType = "trade";
            let res = {};
            try {
                res = await fundApi.qryOrderDetailService({
                    appsheetserialno: item.appsheetserialno
                });
            } catch (e) {
                res.data = {};
            }
            const detail = Object.assign({}, res.data || {}, item);
            this.selectTrade = detail;
            let array = [];
            array.push({
                label: "基金名称：",
                val: `${detail.fundname}[${detail.fundcode}]`
            });
            array.push({
                label: "业务类型：",
                val: this.$cache.getDict("130010", detail.businesscode)
            });
            if (
                detail.businesscode == "036" &&
                detail.targetfundname &&
                detail.targetfundcode
            ) {
                array.push({
                    label: "转入基金：",
                    val: `${detail.targetfundname}[${detail.targetfundcode}]`
                });
            }
            if (this.isBuyType(detail.businesscode)) {
                array.push({
                    label: "申请金额：",
                    val: this.$util.fmtNum(detail.appamount),
                    type: "amount"
                });
            } else {
                array.push({
                    label: "申请份数：",
                    val: detail.appamount ? this.$util.fmtNum(detail.appamount) + "份" : "--"
                });
            }
            array.push({
                label: "下单时间：",
                val: `${this.$util.fmtDate(detail.operdate)} ${this.$util.fmtTime(
                    detail.opertime
                )}`
            });
            array.push({
                label: "申请日期：",
                val: this.$util.fmtDate(detail.transactiondate)
            });
            array.push({
                label: "资金账户：",
                val: `${this.$cache.getDict(
                    "110080",
                    detail.bankcode
                )} (***${detail.depositcard ? detail.depositcard.substr(-4, 4) : "--"})`
            });
            if (detail.custtag == "1") {
                array.push({
                    label: "撤单到：",
                    val: "银行卡",
                    type: "channel"
                });
            }
            this.cancelDetail = array;
            this.cancelVisible = true;
        },
        // 展示汇款账户信息
        async showHkinfo(row) {
            const { data } = await userApi.getInfoByPaychannel({
                paychannel:
                    this.$cache.getParamValue("trade_info") &&
                    this.$cache.getParamValue("trade_info").openremittancechannel
                        ? "0001"
                        : "XSHK"
            });
            if (data.cfgSpecacctinfoList || data.cfgFundSpecacctReqList) {
                // accttype 0-收款  1-付款 2-收付款
                let hkBankArray = [];
                if (row.producttype == "1") {
                    // 私募
                    hkBankArray = data.cfgFundSpecacctReqList.filter((item) => {
                        return item.accttype == "0" || item.accttype == "2";
                    });
                } else {
                    // 公募
                    hkBankArray = data.cfgSpecacctinfoList.filter((item) => {
                        return item.accttype == "0" || item.accttype == "2";
                    });
                }

                if (hkBankArray.length > 0) {
                    this.hkinfo = {
                        acctname: hkBankArray[0].acctname,
                        acctcode: hkBankArray[0].acctcode,
                        bankname: hkBankArray[0].bankname
                    };
                    this.hkinfoVisible = true;
                } else {
                    this.$message.info("未查询到汇款账户信息");
                }
            } else {
                this.$message.info("未查询到汇款账户信息");
            }
        },
        // 撤单操作确认
        cancelConfirm() {
            const _this = this;
            if (_this.isPwdCheck) {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        let _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                        if (_this.cancelType == "redemption") {
                            _this.cancelRedemptionOrder(_pwd);
                        } else {
                            _this.cancelOrder(_pwd);
                        }
                    } else {
                        return false;
                    }
                });
            } else {
                if (_this.cancelType == "redemption") {
                    _this.cancelRedemptionOrder("");
                } else {
                    _this.cancelOrder("");
                }
            }
        },
        // 显示预约赎回撤单
        showRedemptionCancel(item) {
            this.cancelType = "redemption";
            this.selectRedemption = item;
            let array = [];
            array.push({
                label: "产品名称：",
                val: `${item.fundname}[${item.fundcode}]`
            });
            array.push({
                label: "交易类型：",
                val: "预约赎回"
            });
            array.push({
                label: "赎回份额：",
                val: this.$util.fmtNum(item.sellvol) + "份"
            });
            array.push({
                label: "预约时间：",
                val: `${this.$util.fmtDate(item.operdate)} ${this.$util.fmtTime(item.opertime)}`
            });
            this.cancelDetail = array;
            this.cancelVisible = true;
        },
        // 预约赎回撤单
        async cancelRedemptionOrder(pwd) {
            const res = await fundApi.planOperation({
                planno: this.selectRedemption.planno,
                transactionaccountid: this.selectRedemption.transactionaccountid,
                action: "close",
                tradepassword: pwd
            });
            if (res.data) {
                this.ruleForm.tradepwd = "";
                this.cancelVisible = false;
                this.resultVisible = true;
                this.redemptionPageoffset = 1;
                this.getRedemptionRecordList();
            }
        },
        // 撤单
        async cancelOrder(pwd) {
            if (this.selectTrade) {
                // 根据realtaflag的值决定使用哪个API方法
                // 实时TA撤单
                const apiMethod =
                    this.selectTrade.realtaflag == "1"
                        ? fundApi.combTransRealtaCancel
                        : fundApi.cancelOrder;

                // 参数对象
                const params = {
                    originalappsheetno: this.selectTrade.appsheetserialno,
                    transactionaccountid: this.selectTrade.transactionaccountid,
                    buytobuycancelbacktype: this.payChannel, // 充值再转购撤单退款方式 0-银行卡 1-实时TA，不传默认回实时TA
                    tradepassword: pwd
                };

                // 调用API
                const res = await apiMethod(params);

                if (res.data) {
                    this.ruleForm.tradepwd = "";
                    this.cancelVisible = false;
                    this.resultVisible = true;
                    this.pageoffset = 1;
                    this.doAction();
                }
            }
        },
        backHome() {
            this.cancelVisible = false;
            this.$router.push("/home");
        },
        gotoBuy() {
            this.cancelVisible = false;
            this.$router.push("/fund");
        },
        async copy(index) {
            let text = "";
            if (index == 1) {
                text =
                    this.hkinfo.acctname +
                    "\n" +
                    this.hkinfo.acctcode +
                    "\n" +
                    this.hkinfo.bankname;
            } else if (index == 2) {
                text = this.hkinfo.acctname;
            } else if (index == 3) {
                text = this.hkinfo.acctcode;
            } else if (index == 4) {
                text = this.hkinfo.bankname;
            }

            this.$util.copyText(this, text);
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.trade-box {
    width: 1200px;
    background: var(--color-bg-page);
    border: 1px solid var(--color-divided);
    box-sizing: border-box;
    padding-bottom: 20px;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__nav-wrap:after {
            background: var(--color-divided);
        }
        .el-tabs__header {
            margin: 0;
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: var(--color-primary);
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
    .filter-box {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        gap: 16px;
        padding: 20px;
        .input-search {
            width: 320px;
            vertical-align: middle;
            .search-icon {
                margin: 0 5px;
                color: var(--color-text-accent);
            }
            .el-input__inner {
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
        .el-input--mini .el-input__inner {
            height: 32px;
        }
    }
    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 11px;
    }
    .line {
        background: var(--color-divided);
        width: 1px;
        height: 12px;
    }
    .fund-name {
        color: var(--color-text-primary);
        // font-weight: bold;
        font-size: 14px;
    }
    .business-code {
        display: flex;
        justify-content: center;
        align-items: center;
        .custtag {
            width: 22px;
            height: 22px;
            margin-right: 5px;
        }
    }

    .el-table td.el-table__cell div {
        color: var(--color-text-primary);
    }
    .el-table {
        margin: 0 20px 20px;
        width: auto !important;
        border: 1px solid var(--color-divided);
    }
    .el-button.is-plain:hover,
    .el-button.is-plain:focus {
        background-color: transparent;
        border-color: transparent;
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
    }
    .dialog-box {
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        gap: 15px;
        .trade-item {
            display: flex;
            margin-left: 40px;
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
            .label {
                width: 150px;
                font-size: 16px;
                text-align: right;
                color: var(--color-text-regular);
            }
            .val {
                font-size: 16px;
                color: var(--color-text-primary);
                max-width: 380px;
            }
            .amount {
                font-size: 16px;
                color: var(--color-primary);
            }
        }

        .el-form-item__label {
            padding: 0;
        }

        .btn {
            margin-top: 18px;
            width: 180px;
            height: 42px;
            background: var(--color-primary);
            font-size: 16px;
            color: var(--color-text-white);
        }

        .ensure {
            margin-left: 200px;
        }

        .btns {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 40px;
        }

        .back {
            color: var(--color-text-regular);
            background: var(--button-second-bg);
            border-color: transparent;
        }

        .success-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 20px;
            // width: 660px;
            height: 200px;
            border-radius: 6px;
            background: var(--bg-color-lightest);
            .success {
                width: 100px;
                object-fit: contain;
            }
            .tip {
                margin-top: 23px;
                font-size: 26px;
                font-weight: 500;
                line-height: 22px;
                text-align: center;
                color: var(--color-text-primary);
            }
        }

        .warm-tip {
            margin-left: 20px;
            margin-top: 25px;
            font-size: 14px;
            line-height: 20px;
            color: var(--color-text-regular);
        }
    }
    .el-dialog__wrapper.prop .el-dialog__header .el-dialog__title {
        font-size: 18px;
    }
    .page-box {
        padding: 0;
    }
    .el-pagination {
        margin-bottom: 0;
    }

    .hk-class {
        margin: 30px auto 0 auto;
        width: 555px;
        background: var(--bg-color-lightest);
        border-radius: 4px;

        .copy-set {
            color: var(--color-primary);
            text-align: center;
            margin: 0 37px;
            padding: 18px;
            border-bottom: 1px solid var(--color-border-base);
            cursor: pointer;
        }

        .card-info {
            text-align: left;
            padding: 18px 66px;

            .hk-title {
                color: var(--color-text-primary);
                font-size: 16px;
                display: flex;

                .text-wrap {
                    display: inline-block;
                    word-break: break-word;
                    white-space: normal;
                    max-width: 100%;
                }
            }

            .copy {
                white-space: nowrap;
                cursor: pointer;
            }

            .card-detail {
                margin-bottom: 20px;
                display: flex;
                justify-content: space-between;
                color: var(--color-primary);
            }
        }
    }
}
</style>
